<template>
  <div>
    <div v-if="new_account == true">
      <h3>{{ $t('signUp') }}</h3>
    </div>
    <div v-else-if="new_account == false">
      <h3>{{ $t('logIn') }}</h3>
    </div>
    <div v-else>
      <h3>{{ $t('logInOrSignUp') }}</h3>
    </div>
    <br>
    <div>
      <form
        novalidate="novalidate"
        class="simple_form validate_email_form"
        :class="[ new_account == null ? '' : 'validated' ]"
        accept-charset="UTF-8"
      >
        <div
          class="form-group"
          :class="{'has-error': errors.has('email') }"
        >
          <label
            class="email required"
            for="customer_email"
          >{{ $t('form.email') }}</label>
          <input
            id="account_email"
            v-model="email"
            v-validate="'required|email'"
            class="form-control"
            :class="{'input': true, 'is-danger': errors.has('email') }"
            value=""
            :placeholder="$t('form.email')"
            type="text"
            name="email"
            data-vv-validate-on="input"
            @keyup.enter="validateEmail"
          >
          <label
            v-show="errors.has('email')"
            class="error"
            for="account_email"
          >{{ errors.first('email') }}</label>
        </div>
        <div class="form-group">
          <input
            v-if="new_account == null"
            name="commit"
            :value="$t('form.next')"
            class="btn btn-primary btn-block validate_email_btn"
            :class="[ new_account == null ? 'display' : 'no-display']"
            autocomplete="off"
            @click="validateEmail"
            @keyup.enter="validateEmail"
          >
        </div>
      </form>
      <div
        class="login-form"
        :class="[ new_account == null ? 'no-display' : 'display']"
      >
        <Login
          v-if="this.new_account == false"
          :email="email"
        />
        <Signup
          v-else-if="this.new_account == true"
          :email="email"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Login from './login'
import Signup from './signup'

export default {
  inject: ['$validator'],
  components: {
    Login,
    Signup
  },
  data() {
    return {
      email: '',
      new_account: null
    }
  },
  watch: {
    email: function(){
      this.new_account = null
    }
  },
  methods: {
    apiUserEmail(method, body) {
      let tok = document.getElementsByTagName('meta')['csrf-token']
      if (tok) { // csrf-token is null in testing
        tok = tok.getAttribute('content')
      }
      fetch('/customers/customer_email_validations', {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': tok
        },
        method: method,
        body: body
      }).then((response) => {
        if(response.status == 200) {
          this.new_account = false
        }
        else {
          this.new_account = true
        }
      })
    },
    validateEmail(){
      this.$validator.validate().then(valid => {
        if (valid) {
          this.apiUserEmail('POST', JSON.stringify({
            customer: {
              email: this.email
            }
          }))
        } else {
          // After submit, listen for changes on input
        }
      })
    },
  },
}
</script>
